import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useMemo } from "react";

const defaultSettings = {
  isNavigationOpen: true,
};

const useUserSettings = () => {
  const queryClient = useQueryClient();
  const meta = useMemo(() => {
    return {
      persist: true,
    };
  }, []);

  const { data: cachedSettings } = useQuery({
    queryKey: ["settings"],
    queryFn: () => {
      return new Promise((resolve, reject) => {
        try {
          // I am defaulting settings too, because after we get data, it can be undefined.
          // Until we get data placeholderData will be used.
          const settings =
            queryClient.getQueryData(["settings"]) || defaultSettings;
          resolve(settings);
        } catch (error) {
          console.error(error);
          reject(error);
        }
      });
    },
    placeholderData: {
      // This will be only used till we get data from cache.
      ...defaultSettings,
    },
    networkMode: "always",
    meta,
  });

  const { mutate: setSettings } = useMutation({
    mutationFn: (setting) => {
      return new Promise((resolve, reject) => {
        try {
          queryClient.setQueryData(["settings"], (oldSettings) => ({
            ...oldSettings,
            ...setting,
          }));
          resolve(true);
        } catch (error) {
          console.error(error);
          reject(error);
        }
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["settings"] });
    },
  });

  return {
    setSettings,
    settings: cachedSettings,
  };
};

export default useUserSettings;
